var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudying(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#F59E0B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96415 12.3823C8.85753 9.04813 12.2846 7.06949 15.6188 7.96287C16.7196 8.25784 17.6711 8.82799 18.421 9.57928L20.0069 11.1652H17.3538C17.0086 11.1652 16.7288 11.445 16.7288 11.7902C16.7288 12.1353 17.0086 12.4152 17.3538 12.4152H21.5143C21.6801 12.4152 21.8391 12.3493 21.9563 12.2321C22.0735 12.1149 22.1393 11.9559 22.1393 11.7901V7.62967C22.1393 7.28449 21.8595 7.00467 21.5143 7.00467C21.1691 7.00467 20.8893 7.28449 20.8893 7.62967V10.2798L19.3057 8.69622C18.4048 7.79365 17.261 7.1088 15.9423 6.75546C11.9413 5.6834 7.8288 8.05777 6.75674 12.0588C6.6674 12.3922 6.86527 12.7349 7.19868 12.8242C7.5321 12.9136 7.87481 12.7157 7.96415 12.3823ZM20.8037 15.1756C20.4703 15.0862 20.1276 15.2841 20.0382 15.6175C19.1448 18.9517 15.7177 20.9303 12.3836 20.0369C11.2828 19.742 10.3313 19.1718 9.58138 18.4206L7.99647 16.8346H10.6488C10.994 16.8346 11.2738 16.5548 11.2738 16.2096C11.2738 15.8644 10.994 15.5846 10.6488 15.5846L6.48828 15.5846C6.1431 15.5846 5.86328 15.8644 5.86328 16.2096V20.3702C5.86328 20.7153 6.1431 20.9952 6.48828 20.9952C6.83346 20.9952 7.11328 20.7153 7.11328 20.3702V17.7192L8.69667 19.3036C9.59767 20.2063 10.7413 20.891 12.06 21.2444C16.061 22.3164 20.1736 19.942 21.2456 15.941C21.335 15.6076 21.1371 15.2649 20.8037 15.1756Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudying);
export default __webpack_public_path__ + "static/media/studying.89c91fdb9689baa52655a4a6dce08885.svg";
export { ForwardRef as ReactComponent };